/**
 * Entry point for rendering. Used by the API and bundled into the browser, so the live
 * preview, the downloaded SVG and the README image are byte-for-byte identical.
 *
 * Pipeline: GraphData (normalized calendar) -> prepareData (date range) -> type renderer.
 */
import { FONT_STACKS, GraphOptions } from './options';
import { GRAPH_DEFINITIONS } from './registry';
import { escapeXml } from './shared/escape';
import { prepareData } from './shared/range';
import { cardBackground, paint } from './shared/svg';
import { GraphData } from './shared/types';

export type { GraphData, PreparedData } from './shared/types';
export { prepareData } from './shared/range';

export const renderGraph = (data: GraphData, options: GraphOptions): string =>
    GRAPH_DEFINITIONS[options.type].render(prepareData(data, options), options);

/** Friendly error card that still respects the requested theme colors. */
export const renderErrorCard = (message: string, options: GraphOptions): string => {
    const width = options.width || 495;
    const height = options.height || 120;
    const { colors } = options;
    return (
        `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"` +
        ` role="img" aria-label="${escapeXml(message)}" font-family="${escapeXml(FONT_STACKS[options.font])}">` +
        cardBackground(width, height, options) +
        `<text x="${width / 2}" y="${height / 2 - 10}" text-anchor="middle" font-size="15" font-weight="600" fill="${paint(colors.text)}">GitHub Activity Graph</text>` +
        `<text x="${width / 2}" y="${height / 2 + 16}" text-anchor="middle" font-size="13" fill="${paint(colors.label)}">${escapeXml(message)}</text>` +
        '</svg>'
    );
};
